import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserAuthenticationService } from '../services/user-authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  private router = inject(Router);
  private userAuthenticationService = inject(UserAuthenticationService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Ya autenticado
    if (this.userAuthenticationService.isUserAuthenticated) {
      return true;
    }

    // Buscar token en query params
    const tokenFromUrl = route.queryParamMap.get('token');
    if (tokenFromUrl) {
      const isValid = this.userAuthenticationService.validateTokenAndAuthenticate(tokenFromUrl);

      if (isValid) {
        return true;
      }
    }

    // Redirige a login si no hay sesión ni token válido
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }
}
